import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService } from '@services/services.module';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable()
export class ResumenImputacionesService {
  private resumenData: object;
  constructor(private _dsConfig: DsconfigService, private _res: RestConnService) {
    this.resumenData = {
      'resumenImputacionesData': _dsConfig.getUrlBase() + '/ess/v1/imputation/report/filter/date'
    };

  }

  getImputacionesData(initDate: string, endDate: string, userId: string): Observable<any> {
    return this._res
      .get('resumenImputacionesData', { dateEnd: endDate, dateInit: initDate, employeeId: userId }, { disableErrors: false, forceWarning: false, lock: true, retry: 3, collection: this.resumenData })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
